// src/styles/theme.js
import { createTheme } from '@material-ui/core/styles';

const deepBlue = '#0c223f'; // 深蓝
const cyanAccent = '#00e1ff'; // 青色科技亮点
const baseText = '#eaf6ff';  // 白蓝文本
const secondaryText = '#8be9fd'; // 次要文本

// 全局主题配置
const theme = createTheme({
  palette: {
    type: 'dark',
    primary: {
      main: deepBlue,
      contrastText: baseText,
    },
    secondary: {
      main: cyanAccent,
      contrastText: '#00222a',
    },
    background: {
      default: deepBlue,
      paper: '#122f46',
    },
    text: {
      primary: baseText,
      secondary: secondaryText,
    }
  },
  typography: {
    fontFamily: 'Plus Jakarta Sans, Montserrat, Arial, sans-serif',
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 700,
  },
  shape: {
    borderRadius: 18,
  },
  shadows: Array(25).fill('0px 4px 24px 0px rgba(56, 217, 255, 0.12)'),
});

export default theme;
